/**
 * WidgetLoader - Normal Spinner Loader
 */
export default function WidgetLoader() {
  return (
    <div
      style={{
        width: "100%",
        padding: "64px 0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "32px",
          height: "32px",
          border: "4px solid #e5e7eb", // light gray
          borderTopColor: "#f97316",   // orange spin color
          borderRadius: "50%",
          animation: "spin 0.7s linear infinite",
        }}
      />

      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}
